<div class="d-flex justify-content-between w-100">
  <div class="d-flex flex-column gap-2">
    <span class="instruction-card-value">{{ frequency | vbPaymentChangeRecurringPaymentFrequencyLabel }}</span>
    <div class="instruction-card-payment-label" *ngIf="frequency === VariableBenefitPaymentFrequencyEnum.Annually">
      {{ paymentLabel }}
    </div>
  </div>
  <div class="d-flex flex-column gap-2">
    <span class="instruction-card-value" i18n>{{
      activeRecurringPaymentInstruction?.paymentAmount
        | recurringPaymentFrequency : activeRecurringPaymentInstruction?.paymentFrequencyId
    }}</span>
    <div class="instruction-card-payment-label" [style.margin-left]="'auto'" i18n>{{ paymentAmountType }}</div>
  </div>
</div>
